export const FILE_DEFAULT_VALUE: File[] = [];
